
import DistributorProductButton from './DistributorProductButton'
import ProductPrice from './ProductPrice'
import ProductCardImage from './ProductCardImage'
import ProductCardName from './ProductCardName'
import ProductCardVendorName from './ProductCardVendorName'
import ProductCardSku from './ProductCardSku'
import BackorderedLabel from './BackorderedLabel'
import catalogProduct from '~/components/Catalog/mixins/catalog-product'
import { DETAIL_PRODUCT_CARD_ROUTE_NAME } from '~/helpers/route'
import WorkspaceLabel from '~/components/Inventory/WorkspaceLabel'
import DiscontinuedLabel from '~/components/Catalog/ProductCard/DiscontinuedLabel'
import AuthorizedCheckMark from '~/components/Catalog/ProductCard/AuthorizedCheckMark/index.vue'

export default {
  name: 'ProductCard',
  components: {
    AuthorizedCheckMark,
    DiscontinuedLabel,
    BackorderedLabel,
    ProductCardSku,
    WorkspaceLabel,
    ProductCardVendorName,
    ProductCardName,
    ProductCardImage,
    ProductPrice,
    DistributorProductButton,
  },
  mixins: [catalogProduct],
  props: {
    viewportWidth: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    productDetailLinkData() {
      const { item = {} } = this
      return {
        name: DETAIL_PRODUCT_CARD_ROUTE_NAME,
        params: {
          pdid: item?.productDistributorId ?? null,
          pmid: item?.productManufacturerId ?? null,
        },
      }
    },
    productIsHavingLink() {
      return true
    },
    folderName() {
      return this.item?.workSpaceName ?? null
    },
  },
  methods: {
    productCardFilterClickHandler(data) {
      this.$emit('productCardFilterClickHandler', data)
    },
    onAddProductToCart(data) {
      this.$emit('onAddProductToCart', data)
    },
    onChangeQtyInCart(data = {}) {
      this.$emit('onChangeQtyInCart', data)
    },
    onShowAddToInventoryDialog() {
      this.$emit('on-show-add-to-inventory-dialog', {
        productDistributor: this.item,
      })
    },
    onAddToRootFolder(data = {}) {
      this.$emit('on-add-to-root-folder', data)
    },
  },
}
